"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@material/checkbox/dist/mdc.checkbox.css");
require("@rmwc/formfield/styles");
require("@rmwc/ripple/styles");
